import { createAction, handleActions } from 'redux-actions'

import { selectShowBogotaLeaderboard } from 'common/redux/selectors/auth'

const LOAD = 'queue/LOAD'
const RESET = 'queue/RESET'

const load = createAction(LOAD)
const reset = createAction(RESET)

export function setLeaderboardView() {
  return (dispatch, getState) => {
    const showBogotaLeaderboard = selectShowBogotaLeaderboard(getState())
    dispatch(load({showBogotaLeaderboard, teams: null}))
  }
}

export function toggleBogotaLeaderboardView() {
  return (dispatch, getState) => {
    dispatch(reset())
    const { showBogotaLeaderboard } = getState().queue
    dispatch(load({showBogotaLeaderboard: !showBogotaLeaderboard}))
    return Promise.resolve()
  }
}

const initialState = {}

export default handleActions({
    [LOAD]: (state, { payload }) => ({ ...state, ...payload }),
    [RESET]: (state, { payload }) => ({ ...initialState, showBogotaLeaderboard: state.showBogotaLeaderboard}),
}, initialState)
